import React, { FC, useMemo } from "react";
import "./style.scss";
import {
  convertToCamelCase,
  convertToPascalCase,
  convertToTitleCase,
  currencyAmountFormat,
} from "../../../helpers/text-format-helper";
import { get } from "lodash";
import { RootState } from "../../../redux/store";
import { useSelector } from "react-redux";
import { Tooltip as MuiTooltip } from '@mui/material';
import { EXPENSE_TOOLTIP_CONTENT, INCOME_P_AND_L_TOOLTIP_DATA, NUDGE_CONTENT, otherExpenseTypes, overallProfit, saleTypes } from "./constant";
import history from "../../../history";
import { isMobileDevice } from "../../../helpers/device-info-helper";
import { enumerateDaysBetweenDates } from "../../../helpers/moment-helper";
import { DATE_TIME_FORMATS } from "../../../data/constants";
import { rangeInDates } from "../../../helpers/rangeInDates";
import moment from "moment";

interface Props {
  selectedDateRange: {
    startDate: any;
    endDate: any;
  };
  openModal?: () => void;
}

const PnlStatementView: FC<Props> = (props: Props) => {
  const { selectedDateRange, openModal } = props;
  // const { startDate, endDate } = selectedDateRange;
  const { pnlData } = useSelector((state: RootState) => ({
    pnlData: state.pnlStatementReducer.pnlData,
  }));

  const dateRange = useMemo(() => enumerateDaysBetweenDates(selectedDateRange.startDate, selectedDateRange.endDate, DATE_TIME_FORMATS.yearMonthDay), [selectedDateRange])
  const availableDataRange = getAvilableDataRange(pnlData);
  const dateWithNoData = getDateWithNoData(dateRange, availableDataRange);
  const totalFixedExpense = () => {
    let sum = 0;
    otherExpenseTypes.forEach((val: Record<string, string>) => {
      sum = sum + (pnlData?.expense[val.path] || 0)
    })
    return sum;
  }

  function getAvilableDataRange(pnlData: any) {
    return pnlData?.expense?.dayWiseExpense?.map((val: any) => val?.businessDay)
  }

  function getDateWithNoData(dateRange: string[], availableDataRange: string[]) {
    const result = dateRange?.map((val) => {
      if (!availableDataRange?.includes(val)) {
        return val;
      }
      return '';
    })
    const getRange = rangeInDates(result);
    return getRange;
  }


  const handleNudgeClick = (ctaType: string) => {
      openModal?.();
  }

  function getTooltipContent(text: string) {
    return (
      <div className="bg-black w-max max-w-[500px] px-[20px] py-[10px] rounded-[8px] sm:w-[300px]">
        {
          saleTypes?.includes(text) ?
            <div>
              <div className="heading text-[14px] font-[400] text-[#FFFFFF] pb-[15px]">{INCOME_P_AND_L_TOOLTIP_DATA[text].heading}</div>
              {
                INCOME_P_AND_L_TOOLTIP_DATA[text]?.content?.map((val: any) => {
                  return (
                    <div className="flex items-center sm:items-start gap-[10px] text-[12px] pb-[10px] sm:pb-[20px] text-[#FFFFFFCC]">
                      <div className="font-[600] sm:w-[150px]">{`${val?.heading} :`}</div>
                      <div className="font-[400]">{val.description}</div>
                    </div>
                  )
                })
              }
            </div>
            : <div className="flex flex-col gap-[10px]">
              <div className="font-[400] text-[14px] text-[#FFFFFF] ">{EXPENSE_TOOLTIP_CONTENT[text]?.heading}</div>
              <div className="font-[400] text-[12px] text-[#FFFFFFCC]">{`Note: ${EXPENSE_TOOLTIP_CONTENT[text]?.heading}`}</div>
            </div>
        }
      </div>
    )
  }

  function getNudgeContent(type: string, icon = '') {
    return (
      <div className="bg-[#FFFFFF] px-[20px] py-[10px] w-[400px] sm:w-[100%] sm:bg-[#2A77F20D]">
        <div className="flex items-start gap-[20px]">
          <div className="">
            <div className={`rista-sprite ${icon}`}></div>
          </div>
          <div className="flex flex-col text-[#617EAC] text-[14px] gap-[10px]">
            <div className="font-[600]">{NUDGE_CONTENT[type]?.heading}</div>
            {NUDGE_CONTENT[type]?.description
              ? <div className="font-[400] text-left sm:text-[12px]">{NUDGE_CONTENT[type]?.description}</div>
              : <div>
                <div>{'Missing Date Range: '}</div>
                <div>
                  {dateWithNoData?.map((val : any) => {
                    return (
                      <div className="flex items-center sm:text-[12px]">
                        {(val.startDate === val.endDate && val.startDate && val.endDate)?
                        <div>
                          <div>{`${moment(val.startDate).format(DATE_TIME_FORMATS.dayMonthYear)}, `}</div>
                        </div>
                        :<div className="flex items-center">
                        {val.startDate && <div>{`${moment(val.startDate).format(DATE_TIME_FORMATS.dayMonthYear)} - `}</div>}
                        <div>{moment(val.endDate).format(DATE_TIME_FORMATS.dayMonthYear)}</div>
                        </div>
                       }
                      </div>
                    )
                  })
                  }
                </div>
                <div>{
                }</div>
              </div>
            }
            {
              NUDGE_CONTENT[type]?.CTA && <div onClick={() => handleNudgeClick(NUDGE_CONTENT[type]?.CTA)} className="border cursor-pointer border-[#C5DBFF] w-max rounded-[4px]">
                <div className="text-[14px] font-[400] text-[#2A77F2] px-[20px] py-[10px]">{NUDGE_CONTENT[type]?.CTA}</div>
              </div>
            }
          </div>
        </div>
      </div>
    )
  }

  function renderHeading(text: string, showBorderTop: boolean = true) {
    return (
      <div
        className={`border border-[#DEDEDF] bg-[#DEE8F8] px-24 py-14 flex
          items-center ${showBorderTop ? "" : "border-t-0"}
        `}
      >
        <p className="text-16 font-bold uppercase mr-16">{text}</p>
        {/* <p className="text-13 text-[#666666]">
          This {text?.toLowerCase()} data is for date range {startDate} to{" "}
          {endDate}
        </p> */}
      </div>
    );
  }

  function renderSubHeading(text: string, showNudge = false, nudgeType = '', icon = '') {
    return (
      <div className="border border-[#DEDEDF]">
        <div
          className={` bg-[#F8F8F8] border-t-0 px-24 py-14 flex items-center gap-[10px]`}
        >
          <p className="text-15 font-semibold uppercase text-[#565656]">{text}</p>
          <MuiTooltip
            arrow={true}
            placement={isMobileDevice() ? "bottom" : "right"}
            enterTouchDelay={0}
            title={getTooltipContent(text)}
            componentsProps={{ tooltip: { sx: { background: "transparent", } } }}
          >
            <div className="rista-sprite ic-tooltip"></div>
          </MuiTooltip>
        </div>
        {showNudge && isMobileDevice() &&
          <div className="border-t border-[#DEDEDF]">
            {getNudgeContent(nudgeType, icon)}
          </div>
        }
      </div>
    );
  }

  function renderRow(rowConfig: {
    label: string;
    value: any;
    fontClass?: string;
    isAmount?: boolean;
    showNudge?: boolean;
    nudgeType?: string;
    nudgeBottomSpace?: string,
    nudgeIcon?: string
  }) {
    const { label, value, fontClass = "", isAmount = true, showNudge = false, nudgeType = '', nudgeBottomSpace = '135px', nudgeIcon = '' } = rowConfig;
    return (
      <div className={`border border-[#DEDEDF] border-t-0 flex ${fontClass === 'text-18 font-bold' ? 'bg-[#DEE8F8] border-[#95AACB]' : ''}`}>
        <div
          className={`w-1/2 min-w-[50%] sm:min-w-[68%] sm:w-[68%] px-24 sm:px-[15] py-14 border-r border-[#DEDEDF] capitalize
            ${fontClass || "text-15 text-[#404040]"} ${fontClass === 'text-18 font-bold' ? 'border-[#95AACB] text-[#565656] font-bold' : ''}
           ${value === 0 ? 'text-[#AAAAAA]': ''} ml-[12px]`}
        >
          {label}
          {/* {true ? (
            <span className="text-12 text-[#9A9A9A] font-normal">
              (Description)
            </span>
          ) : null} */}
        </div>
        <div
          className={`w-1/2 min-w-[50%] sm:w-[28%] sm:min-w-[28%] px-40 sm:px-5 py-14 text-right ${fontClass || "text-14 text-[#404040]"
            } ${(isAmount && !value) ? 'text-[#AAAAAA]':''}`}
        >
          {isAmount ? currencyAmountFormat(value, 2) : value}
        </div>
        {
          showNudge && !isMobileDevice() &&
          <MuiTooltip
            arrow={true}
            placement={"right"}
            title={getNudgeContent(nudgeType , nudgeIcon)}
            PopperProps={{style:{zIndex:0}}}
            componentsProps={{ tooltip: { sx: { background: "transparent", bottom: isMobileDevice() ? 30 : nudgeBottomSpace, left: '30px',} } }}
            open={true}
          >
            <div className="rista-sprite ic-tooltip"></div>
          </MuiTooltip>
        }
      </div>
    );
  }

  function renderIncomeData() {
    let subValues = ["gross", "discount", "charges", "net"];
    let chargeAndDiscount = ["discount", "charges"];
    return (
      <>
        {renderHeading("income")}
        {saleTypes?.map((type: string) => {
          return (
            <>
              {renderSubHeading(type)}
              {subValues?.map((subVal: string, index: number) => {
                let labelStr = `${convertToTitleCase(
                  subVal
                )} ${chargeAndDiscount?.includes(subVal) ? 'on' : ''}  ${convertToTitleCase(type)}`,
                  value =
                    pnlData?.income?.[convertToCamelCase(type)]?.[
                    `${subVal}${convertToPascalCase(type)}`
                    ],
                  fontClass = index === 3 ? "text-15 font-semibold" : "";
                return renderRow({ label: labelStr, value, fontClass });
              })}
            </>
          );
        })}
        {renderRow({
          label: "Total Net Sales",
          value: pnlData?.totalNetSales,
          fontClass: "text-18 font-bold",
        })}
      </>
    );
  }

  function renderExpensesData() {
    return (
      <>
        {renderHeading("expenses", false)}
        {renderSubHeading("Cost of Goods sold", pnlData?.expense?.goodSoldCost?.totalGoodSoldCost === 0, 'COST_OF_GOODS', 'ic-cost-of-goods')}
        {renderRow({
          label: "Cost of Material",
          value: pnlData?.expense?.goodSoldCost?.materialCost,
        })}
        {renderRow({
          label: "Cost of Supplies",
          value: pnlData?.expense?.goodSoldCost?.suppliesCost,
        })}
        {renderRow({
          label: "Total Cost of Goods Sold",
          value: pnlData?.expense?.goodSoldCost?.totalGoodSoldCost,
          fontClass: "text-15 font-semibold",
          showNudge: Number(pnlData?.expense?.goodSoldCost?.totalGoodSoldCost) === 0,
          nudgeType: 'COST_OF_GOODS',
          nudgeBottomSpace: '135px',
          nudgeIcon: 'ic-cost-of-goods'
        })}
        {renderSubHeading("Commission", pnlData?.expense?.commission?.totalCommission === 0, 'Commission', 'ic-cost-of-goods')}
        {renderRow({
          label: "Swiggy",
          value: pnlData?.expense?.commission?.swiggy,
        })}
        {renderRow({
          label: "Zomato",
          value: pnlData?.expense?.commission?.zomato,
        })}
        {renderRow({
          label: "Total Commission",
          value: pnlData?.expense?.commission?.totalCommission,
          fontClass: "text-15 font-semibold",
          showNudge: Number(pnlData?.expense?.commission?.totalCommission) === 0,
          nudgeType: 'Commission',
          nudgeIcon: 'ic-cost-of-goods'
        })}
        {renderRow({
          label: "Total Variable Expense",
          fontClass: "text-18 font-bold",
          value: get(pnlData?.expense, 'totalVariableExpense'),
        })}
        {renderSubHeading("Fixed expense", (totalFixedExpense() === 0 || dateWithNoData?.length > 0), !(totalFixedExpense() === 0 ) ? 'FIXED_EXPENSE1' : 'FIXED_EXPENSE', 'ic-fixed-expense')}
        {otherExpenseTypes?.map((typeObj: any, index) => {
          let val = get(pnlData?.expense, typeObj?.path);
          return renderRow({
            label: typeObj?.label,
            value: val,
            fontClass: typeObj?.fontClass || "",
            isAmount: typeObj?.isAmount,
            showNudge: (index === (otherExpenseTypes.length - 1) && (totalFixedExpense() === 0 || dateWithNoData?.length > 0)),
            nudgeType: !(totalFixedExpense() === 0 ) ? 'FIXED_EXPENSE1' : 'FIXED_EXPENSE',
            nudgeBottomSpace: '340px',
            nudgeIcon: 'ic-fixed-expense'
          });
        })}
        {renderSubHeading('PETTY CASH EXPENSES', get(pnlData?.expense, 'pettyCashExpense') === 0, 'PETTY_CASH', 'ic-petty-cash')}
        {renderRow({
          label: "Net Petty Cash Expenses",
          value: get(pnlData?.expense, 'pettyCashExpense'),
          showNudge: get(pnlData?.expense, 'pettyCashExpense') === 0,
          nudgeType: 'PETTY_CASH',
          nudgeBottomSpace: '40px',
          nudgeIcon: 'ic-petty-cash'
        })}
        {renderRow({
          label: "Total Fixed Expense",
          value: totalFixedExpense(),
          fontClass: "text-15 font-semibold",
        })}
        {renderRow({
          label: "TOTAL EXPENSE",
          value: totalFixedExpense() + pnlData?.totalNetSales,
          fontClass: "text-18 font-bold",
        })}
        <div className="pt-[20px]">
          {overallProfit?.map((typeObj: any) => {
            let val = get(pnlData?.expense, typeObj?.path);
            return renderRow({
              label: typeObj?.label,
              value: val,
              fontClass: typeObj?.fontClass || "",
              isAmount: typeObj?.isAmount,
            });
          })}
        </div>
      </>
    );
  }

  return (
    <div className={`m-20 mb-0 p-32 bg-white sm:m-16 sm:p-12 w-[60%] sm:w-[90%]`}>
      <div>{renderIncomeData()}</div>
      <div className="mt-[20px]">{renderExpensesData()}</div>
    </div>
  );
};

export default PnlStatementView;
